import { HandlerAppInfo } from '../data/handlerApps';

type Props = {
  app?: HandlerAppInfo;
  fallbackName?: string;
  onClick: () => void;
};

export default function AppTile({ app, fallbackName, onClick }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex items-center gap-4 rounded-lg border border-border bg-card p-3 text-left transition-colors hover:bg-accent w-full"
    >
      {app?.base64Logo ? (
        <img
          src={app.base64Logo}
          alt={app.name}
          className="size-10 shrink-0 rounded-lg object-contain"
        />
      ) : (
        <div className="size-10 shrink-0 rounded-lg bg-muted" />
      )}
      <span className="text-sm font-semibold text-foreground">
        {app?.name ?? fallbackName ?? 'Unknown app'}
      </span>
    </button>
  );
}
